module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k4vpB"))).then(() => parcelRequire('1iHdE'));